<div [classList]="border ? 'border card placeholder-glow' : 'card placeholder-glow'">
  <div class="img placeholder"></div>
  <div class="content">
    <div class="top">
      <div class="info">
        <span class="col-3 placeholder"></span>
        <span class="separator">|</span>
        <span class="col-4 placeholder"></span>
        <span class="separator">|</span>
        <span class="col-3 placeholder"></span>
      </div>
      <h1 class="title mt-2 col-6 placeholder"></h1>
    </div>
    <div class="desc">
      <span class="me-1 col-4 placeholder"></span>
      <span class="me-1 col-3 placeholder"></span>
      <span class="me-1 col-2 placeholder"></span>
      <span class="me-1 col-6 placeholder"></span>
      <span class="me-1 col-4 placeholder"></span>
      <span class="me-1 col-3 placeholder"></span>
      <span class="me-1 col-2 placeholder"></span>
      <span class="me-1 col-6 placeholder"></span>
    </div>

    <span class="me-1 col-6 placeholder link-primary"></span>
  </div>
</div>
